import IndexPage from './index'
import FormPage from './form'
import initMixin from '@/common/js/init-mixin'
import { mapState } from 'vuex'
import Loading from '@/components/loading'
import fontSizeMixin from '@/common/js/font-size-mixin'

const VARIBLE = new Map([
  ['WECHAT_NICKNAME', 'wechat-nickname'], // 微信昵称
  ['SCORE', 'score'], // 分数
  ['APPLICANT', 'applicant'], // 姓名（表单键值为name的输入项的值）
  ['CHILD_NAME', 'child-name '] // 孩子姓名（表单键值为childName的输入项的值）
])


const page403 = {
  props: ['deniedReason'],
  beforeCreate() {
    this.$audio.hide()
  },
  render() {
    return (
      <div class="page page-403">
        <msg
          title=""
          description={this.deniedReason}
          icon="warn"
        />
      </div>
    )
  }
}


export default {
  mixins: [initMixin, fontSizeMixin],
  components: {
    IndexPage,
    FormPage,
    page403,
  },
  data() {
    return {
      deniedReason: null,
      checked: false
    }
  },
  async mounted() {
    this.windowResizeHandler()
    window.addEventListener('resize', this.windowResizeHandler)

    this.$store.dispatch('activitiesManager/setHomePageUrl', this.$storage.getItem('org_index'))

    // 根据状态信息决定跳转页面
    const statusResp = await this.startUp()

    if (!statusResp.user) {
      statusResp.user = {}
    }

    this.isAfterSubmitForm = parseInt(statusResp.status) > 1
    this.$storage.remove('start_up_status')
    this.$storage.setItem('start_up_status', statusResp.status)
    this.$storage.setItem('nickname', statusResp.user.nickname)
    this.$storage.setItem('name', statusResp.user.name)
    this.$storage.setItem('participant_index', statusResp.user.id)

    // 设置分享
    const shareInfo = this.$store.state.activitiesManager.share
    const { descriptionBeforeSubmit, useSetting, image } = shareInfo

    await this.setConfig(shareInfo, descriptionBeforeSubmit, image)

    // 检查城市限制
    const checkResult = await this.checkCityLimit()

    if (!checkResult.granted) {
      return this.deniedReason = checkResult.msg
    }

    this.checked = true

    // 发送分享信息，统计接口
    await this.sendPvInfo()
  },
  computed: mapState('activitiesManager', {
    currentPage: state => {
      return state.page
    }
  }),
  watch: {
    currentPage(newVal, oldVal) {
      this.$nextTick(_ => {
        this.windowResizeHandler()
      })
    }
  },
  render() {
    const Page = this.currentPage

    if(this.checked) return <Page />
    if (this.deniedReason) return <page-403 deniedReason={this.deniedReason} />

    return <Loading />
  }
}